// extracted by mini-css-extract-plugin
export default {"root":"UserProfilePersonal_root__LkzoH","list":"UserProfilePersonal_list__dwPgj","title":"UserProfilePersonal_title__j07Su"};